import delegate from 'delegate-it';
import FilterOptions from './FilterOptions.js';

class Filter {
  constructor(rootElement) {
    this.rootElement = rootElement;
    this.tagsChangeEvent = new CustomEvent('filter:tags-changed', {
      bubbles: true,
      cancelable: true,
    });

    this.initOptionsTypeTag();
    this.initUiState();
    this.attachEvents();
    this.init();
  }

  initOptionsTypeTag() {
    this.optionsTypeTag = Array.from(this.rootElement.querySelectorAll('[data-entity="options-group"]'));
    this.optionsTypeTagComponents = this.optionsTypeTag.map((element) => {
      const component = new FilterOptions(element, {
        changeEvent: this.tagsChangeEvent,
      });

      return component;
    });
  }

  initUiState() {
    this.uiState = {
      modalVisibility: 'hidden',
      activeOptionsCount: 0,
    };
  }

  init() {
    this.updateTogglerTitle();
  }

  attachEvents() {
    delegate(this.rootElement, '[data-entity="modal-toggler"]', 'click', this.togglerClickHandler.bind(this));
    delegate(this.rootElement, '[data-entity="form-reset"]', 'click', this.resetClickHandler.bind(this));
    this.rootElement.addEventListener('filter:tags-changed', this.optionsTypeTagChangeHandler.bind(this));
  }

  togglerClickHandler() {
    this.uiState.modalVisibility = this.uiState.modalVisibility === 'hidden' ? 'shown' : 'hidden';

    this.renderModal();
  }

  resetClickHandler() {
    this.form = this.rootElement.querySelector('[data-entity="form"]');

    if (!this.form) {
      return;
    }

    this.form.reset();

    this.optionsTypeTagComponents.forEach((component) => {
      component.resetOptions();
    });
  }

  optionsTypeTagChangeHandler() {
    this.updateTogglerTitle();
  }

  updateTogglerTitle() {
    this.uiState.activeOptionsCount = this.calcActiveOptions();
    this.renderTogglerTitle();
  }

  calcActiveOptions() {
    let counter = 0;

    this.optionsTypeTagComponents.forEach((component) => {
      counter += component.getActiveOptionsCount();
    });

    return counter;
  }

  renderModal() {
    this.modal = this.rootElement.querySelector('[data-entity="modal"]');

    if (!this.modal) {
      return;
    }

    const { modalVisibility } = this.uiState;

    if (modalVisibility === 'hidden') {
      this.modal.classList.add('filter__modal_hidden');
      this.modal.classList.remove('filter__modal_shown');
    }

    if (modalVisibility === 'shown') {
      this.modal.classList.add('filter__modal_shown');
      this.modal.classList.remove('filter__modal_hidden');
    }
  }

  renderTogglerTitle() {
    this.filterOptionsCounter = this.rootElement.querySelector('[data-entity="filter-opt-counter"]');

    if (!this.filterOptionsCounter) {
      return;
    }

    const { activeOptionsCount } = this.uiState;

    if (!activeOptionsCount) {
      this.filterOptionsCounter.textContent = '';
    }

    if (activeOptionsCount > 0) {
      this.filterOptionsCounter.textContent = ` (${activeOptionsCount})`;
    }
  }
}

export default Filter;
